import { Moment } from '@intelipost-js/secure-providers';

export default {
  loading: false,
  hasGeneratedReport: false,
  deliveryMethodsList: [''],
  filter: {
    dateRange: {
      start: Moment()
        .subtract(1, 'days')
        .endOf('day')
        .format('YYYY-MM-DD'),
      end: Moment()
        .endOf('day')
        .format('YYYY-MM-DD'),
    },
    report_type: null,
    logistic_provider_id: null,
    sales_channel: null,
    origin_zip_codes: [],
    weight_ranges: 0,
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/freight-cost/store/states.js